import React, { useEffect, useState } from 'react'
import { UpdateCountryPreference } from 'api/Clients/Types/UpdateCountryPreference'
import { WalletCurrencyDto } from 'api/Wallet/Types/WalletCurrencyDto'
import { useAppDispatch, useAppSelector } from 'store'
import {
  fetchClientLanguagesAction,
  fetchClientOnboardingFlowTypeAction,
  fetchTickmillProductsAction,
} from 'store/clients/clients.actions'
import { fetchTickmillCompaniesAction } from 'store/identity/identity.actions'
import { useApiClient } from 'utils/api/ApiClient'
import { ClientsApiClient } from 'utils/api/clientsApi'
import { IdentityApiClient } from 'utils/api/identityApi'
import { WalletsApiClient } from 'utils/api/walletsApiClient'
import { isEmpty } from 'utils/is-empty'

import { EditCountryForm } from './EditCountryForm'
import { CountryPreference } from './types'

interface Props {
  data: CountryPreference
  onCloseModal(): void
  onSubmit(values: UpdateCountryPreference): void
}

const EditCountryPage: React.FC<Props> = ({ data, onSubmit, onCloseModal }) => {
  const identityApiClient = useApiClient(IdentityApiClient)
  const walletsApiClient = useApiClient(WalletsApiClient)
  const clientsApiClient = useApiClient(ClientsApiClient)

  const [isLoading, setLoading] = useState(false)
  const [currencies, setCurrencies] = useState<WalletCurrencyDto[]>([])

  const language = useAppSelector((state) => state.clients.language)
  const tickmillCompanies = useAppSelector((state) => state.identity.tickmillCompanies)
  const onboardingFlowTypes = useAppSelector((state) => state.clients.onboardingFlowTypes)
  const tickmillProducts = useAppSelector((state) => state.clients.tickmillProducts)

  const dispatch = useAppDispatch()

  useEffect(() => {
    setLoading(true)
    if (isEmpty(language)) {
      dispatch(fetchClientLanguagesAction(clientsApiClient))
    }
    if (isEmpty(onboardingFlowTypes)) {
      dispatch(fetchClientOnboardingFlowTypeAction(clientsApiClient))
    }
    if (isEmpty(tickmillProducts)) {
      dispatch(fetchTickmillProductsAction(clientsApiClient))
    }

    if (isEmpty(tickmillCompanies)) {
      dispatch(fetchTickmillCompaniesAction(identityApiClient))
    }
    setLoading(false)
  }, [dispatch, language, tickmillCompanies]) // eslint-disable-line react-hooks/exhaustive-deps

  const setCurrencyOnTickmillCompany = async (tickmillCompanyId: number | null) => {
    if (tickmillCompanyId) {
      const response = await walletsApiClient.getWalletAvailableCurrencies(tickmillCompanyId)
      setCurrencies(response)
    } else {
      setCurrencies([])
    }
  }

  return (
    <EditCountryForm
      isOpen
      onClose={onCloseModal}
      isLoading={isLoading}
      data={data}
      onSubmit={onSubmit}
      setCurrencyOnTickmillCompany={setCurrencyOnTickmillCompany}
      languages={language}
      currencies={currencies}
      tickmillCompanies={tickmillCompanies}
      onboardingFlowTypes={onboardingFlowTypes}
      tickmillProducts={tickmillProducts}
    />
  )
}

export default EditCountryPage
